<template>
    <div class="wrapper">
        <nav id="sidebar">
            <i class="fa fa-plus tb-tool" v-on:click.prevent="uploading = true">
                <span class="tb-text">{{ $t("addLayer") }}</span>
            </i>
            <div>
                <ul class="cd-accordion-menu">
                    <tree-menu :model="treeData" @delete="deleteLayer" @edit="editLayer"></tree-menu>
                </ul>
            </div>
        </nav>
        <div v-if="loading" id="content">
            <div>{{ $t("loading") }}</div>
        </div>
        <div v-else id="content">
            <div v-if="uploading">
                <Upload v-if="!upload.id" @onUploaded="saveUploadId" />
                <div v-else>
                    <p>{{ $t("uploadLogs") }}:</p>
                    <table
                        class="table table-bordered table-hover"
                        style="max-width: 960px; margin: 0 auto;"
                    >
                        <thead class="thead-light">
                            <tr>
                                <th class="w-15">{{ $t("id") }}</th>
                                <th class="w-60">{{ $t("log") }}</th>
                                <th class="w-25">{{ $t("time") }}</th>
                            </tr>
                        </thead>
                        <tr
                            v-for="(item, index) in upload.logs"
                            v-bind:key="index"
                        >
                            <td>{{ item.id }}</td>
                            <td>{{ item.log }}</td>
                            <td>{{ item.created_at }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div style="max-width: 960px; margin: 0 auto;" v-else>
                <vuetable
                    ref="vuetable"
                    :api-url="apiUrl"
                    :fields="fields"
                    :show-sort-icons="true"
                    :per-page="25"
                    pagination-path
                    :css="css.table"
                    @vuetable:pagination-data="onPaginationData"
                ></vuetable>
                <vuetable-pagination
                    ref="pagination"
                    class="pull-right"
                    @vuetable-pagination:change-page="onChangePage"
                    :css="css.pagination"
                ></vuetable-pagination>
            </div>
        </div>
        <confirm-dialog
            v-if="confirm.show"
            :header="$t('header.deleteLayer')"
            :body="$t('content.deleteLayer')"
            @close="confirmDeletion"
        ></confirm-dialog>
        <layer-dialog
            v-if="layerEdit.show"
            :header="$t('header.editLayer')"
            :body="$t('content.editLayer')"
            :data="layerEdit"
            @close="saveLayer"
        ></layer-dialog>
        <footer-area></footer-area>
    </div>
</template>

<script>
import FooterArea from "@/components/shared/FooterArea.vue";
import Upload from "@/components/shared/Upload.vue";
import ConfirmDialog from "@/components/shared/ConfirmDialog.vue";
import LayerDialog from "@/components/admin/LayerDialog.vue";
import TreeMenu from "@/components/map/TreeMenu.vue";
import Vuetable from "vuetable-2";
import VuetablePagination from "../../components/admin/VuetablePagination";
import {
    upload as uploadService,
    layers as layersService
} from "../../services/index.js";
import CssConfig from "../../components/admin/VuetableConfig.js";

export default {
    name: "Admin",
    data: function() {
        return {
            css: CssConfig,
            layers: {},
            uploading: true,
            apiUrl: "",
            fields: [],
            loading: false,
            upload: {
                id: null,
                logs: []
            },
            confirm: {
                show: false
            },
            layerEdit: {
                show: false
            },
            treeData: {}
        };
    },
    components: {
        Upload,
        Vuetable,
        VuetablePagination,
        FooterArea,
        ConfirmDialog,
        TreeMenu,
        LayerDialog
    },

    methods: {
        saveUploadId(data) {
            this.upload.id = data.id;

            return this.pollForLogs()
                .then(() => this.pollForLogs())
                .then(() => this.pollForLogs())
                .then(() => this.loadLayersList());
        },

        pollForLogs() {
            const lastUpload = this.upload.logs.length
                ? this.upload.logs[this.upload.logs.length - 1].created_at
                : null;

            return uploadService
                .getUploadLogs(this.upload.id, lastUpload)
                .then(logs => {
                    this.upload.logs = [...this.upload.logs, ...logs];
                })
                .catch(err => {
                    console.log(err);
                })
                .then(() => new Promise(resolve => setTimeout(resolve, 1000)));
        },

        onPaginationData(paginationData) {
            this.$refs.pagination.setPaginationData(paginationData);
        },

        onChangePage(page) {
            this.$refs.vuetable.changePage(page);
        },

        showLayerData(layer) {
            this.uploading = false;
            this.loading = true;

            return layersService
                .getColumns(layer)
                .then(data => {
                    this.apiUrl = "/api/layers/" + layer;
                    this.fields = data.slice(0, 5);
                    this.$refs.vuetable.refresh();
                    this.loading = false;
                })
                .catch(err => {
                    console.log(err);
                    this.loading = false;
                });
        },

        editLayer(layer) {
            console.log("Editing layer", layer);

            this.layerEdit.show = true;
        },

        saveLayer(data) {
            this.layerEdit.show = false;

            if(!data) {
                console.log('No aciton to do');
                return;
            }

            const { id_sup, type, order, map_order, name, label, mapfile, checked, info, min_scale, max_scale, position } = data;

            console.log("Id set: " + !!data.id);
        },

        deleteLayer(layer) {
            this.confirm.layer = layer;
            this.confirm.show = true;
        },

        confirmDeletion(confirm) {
            if (confirm) {
                layersService
                    .delete(this.confirm.layer)
                    .then(() => {
                        this.loadLayersList();
                        this.confirm.show = false;
                    })
                    .catch(err => {
                        console.log("Error occured", err);
                        this.confirm.show = false;
                    });
            } else {
                this.confirm.show = false;
            }
        },

        loadLayersList() {
            layersService
                .list()
                .then(data => {
                    this.layers = [];
                    console.log('data', data);
                    const tree = JSON.parse(data[0].tree);
                    this.treeData = { label: 'Groups', children: tree };
                })
                .catch(err => {
                    console.log(err);
                });
        }
    },

    mounted() {
        this.loadLayersList();
    }
};
</script>

<style scoped lang="stylus">
.wrapper {
  display: flex;
  width: 100%;
}

#sidebar {
  width: 400px;
  position: fixed;
  text-align: left;
  top: 0;
  left: 0;
  padding: 0;
  height: calc(100vh - 35px);
  z-index: 999;
  background: #3c4858;
  color: #fff;
  transition: all 0.3s;
}

#content {
  margin-left: 400px;
  padding: 20px;
  width: 100%;
  height: calc(100vh - 35px);
  background-color: white;
}

.tb-tool {
  cursor: pointer;
  padding: 4px;
}

.tb-text {
  margin-left: 4px;
}

.layer {
  cursor: pointer;
}

.layer-item {
    margin-left: 0;
    margin-right: 10px;
}

ul {
    padding-left: 10px;
}
</style>
